export enum CookEscalationResolutions {
  SEND_TO_RETRAINING = "SEND_TO_RETRAINING",
  MARK_BLACKLISTED = "MARK_BLACKLISTED",
  NONE="NONE"
}
